import React from 'react'
import ArtistBubble from './ArtistBubble'
import ArtistComments from './ArtistComments'
import FavoriteArtists from './FavoriteArtists'

const ArtistDisplay = ({
  artists,
  onArtistChange,
  onEdit,
  onRemoveArtist,
  isFutureEvent = false
}) => {
  const displayedArtists = artists.filter(artist =>
    artist.name.trim() && artist.confirmed
  )

  if (displayedArtists.length === 0) return null

  const handleToggleSeen = (index) => {
    const artist = artists[index]
    onArtistChange(index, 'seen', !artist.seen)
  }

  const handleToggleFavorite = (index) => {
    const artist = artists[index]
    onArtistChange(index, 'favorite', !artist.favorite)
  }

  const handleToggleWantToSee = (index) => {
    const artist = artists[index]
    onArtistChange(index, 'wantToSee', !artist.wantToSee)
  }

  const handleCycleState = (index) => {
    const artist = artists[index]

    // Cycle through states: default → wanted (amber) → seen (green) → default
    if (!artist.wantToSee && !artist.seen) {
      // Default → Wanted to see (amber)
      onArtistChange(index, 'wantToSee', true)
    } else if (artist.wantToSee && !artist.seen) {
      // Wanted to see → Saw them (green)
      onArtistChange(index, 'wantToSee', false)
      onArtistChange(index, 'seen', true)
    } else if (artist.seen) {
      // Saw them → Default
      onArtistChange(index, 'seen', false)
    }
  }

  const handleEdit = (artistName) => {
    const actualIndex = artists.findIndex(a => a.name === artistName)
    onEdit(actualIndex)
  }

  const handleRemove = (artistName) => {
    const actualIndex = artists.findIndex(a => a.name === artistName)
    onRemoveArtist(actualIndex)
  }

  return (
    <div className="mb-4">
      <h4 className="text-sm font-medium text-gray-200 mb-3">🎤 Artists</h4>
      <div className="text-gray-300 leading-relaxed min-h-[2rem]">
        {artists.map((artist, index) => {
          // Only render confirmed artists with names
          if (!artist.name?.trim() || !artist.confirmed) return null

          return (
            <React.Fragment key={`artist-${index}`}>
              <ArtistBubble
                artist={artist}
                index={index}
                onToggleSeen={() => handleToggleSeen(index)}
                onEdit={() => handleEdit(artist.name)}
                onToggleFavorite={() => handleToggleFavorite(index)}
                onToggleWantToSee={() => handleToggleWantToSee(index)}
                onRemove={() => handleRemove(artist.name)}
                onCycleState={() => handleCycleState(index)}
                isFutureEvent={isFutureEvent}
              />
              {index < artists.length - 1 && artist.name?.trim() && artist.confirmed && (
                <span className="text-gray-500"> </span>
              )}
            </React.Fragment>
          )
        }).filter(Boolean)}
      </div>

      <ArtistComments
        artists={artists}
        onEdit={handleEdit}
      />

      <FavoriteArtists
        artists={artists}
        onToggleSeen={handleToggleSeen}
        onToggleFavorite={handleToggleFavorite}
      />
    </div>
  )
}

export default ArtistDisplay